import React, { useEffect } from "react";
import { ImageURL } from "../../../Util/axios_core_helper";
import { useDispatch, useSelector } from "react-redux";
import { GetAboutUsSectionList } from "../../WelcomeSection/WelcomeSectionSlice";

const AboutSection = () => {
  const { aboutSectionList } = useSelector((state) => state.WelcomeSection);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(GetAboutUsSectionList());
  }, []);

  if (!aboutSectionList || aboutSectionList.length === 0) {
    return null;
  }
  return (
    <section className="wpo-about-section">
      <div className="container">
        {aboutSectionList?.map((contact, index) => (
          <div className="wpo-about-wrap" key={index}>
            <div className="row">
              {index % 2 === 0 ? (
                <>
                  <div className="col-lg-6 col-md-12 col-12">
                    <div
                      className="wpo-about-item wow fadeInLeftSlow"
                      data-wow-duration="1500ms"
                    >
                      <div className="wpo-about-img">
                        <img
                          className="BigImageIncreaseSize"
                          src={`${ImageURL}${contact.imagePath}`}
                          alt={contact.title}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12 col-12">
                    <div
                      className="wpo-about-text wow fadeInRightSlow"
                      data-wow-duration="1600ms"
                    >
                      <h2>{contact.title}</h2>
                      <h4>{contact.subTitle}</h4>
                      <p>{contact.description}</p>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="col-lg-6 col-md-12 col-12 order-lg-2 order-1">
                    <div
                      className="wpo-about-item wow fadeInRightSlow"
                      data-wow-duration="1800ms"
                    >
                      <div className="wpo-about-img">
                        <img
                          className="BigImageIncreaseSize"
                          src={`${ImageURL}${contact.imagePath}`}
                          alt={contact.title}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12 col-12 order-lg-1 order-2">
                    <div
                      className="wpo-about-text wow fadeInLeftSlow"
                      data-wow-duration="1700ms"
                    >
                      <h2>{contact.title}</h2>
                      <h4>{contact.subTitle}</h4>
                      <p>{contact.description}</p>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AboutSection;
